<template>
  <div class="table-container">
    <Table
      :columns="columns"
      :data="list"
      :loading="loading"
      :noDataText="`<div class='no_data'>
        <img  src='${require('@/assets/images/no-data.png')}'>
      <span class='text'> ${$t('暂无记录')} </span>
  </div>`"
    >
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    list: Array,
    columns: Array,
    loading: Boolean,
  },
}
</script>
<style scoped lang="less">
.table-container {
  padding: 10px 48px 20px;
  .ivu-table-wrapper {
    ::v-deep .ivu-spin-fix {
      // background: rgba(#0a0a0c, 0.8);
      .ivu-spin-dot {
        background-color: #fff;
      }
    }
    ::v-deep .ivu-table {
      background: none;

      &::before {
        content: none;
      }
      .ivu-table-header {
        table {
          height: 40px;
          border-collapse: unset;
        }
        th {
          background: #ffffff;
          font-size: 14px;
          font-weight: 500;
          color: #616888;
          border-top: 1px solid #e8e8e8;
          border-top: 1px solid #e8e8e8;
        }
      }
      .ivu-table-body {
        td {
          background: #ffffff;
          font-size: 14px;
          color: #333333;
          border-bottom-color: #e8e8e8;
          padding: 10px 0;
        }
      }
      .ivu-table-tip {
        td {
          background: none;
          border: none;
        }
        span:not(.text) {
          position: relative;
          display: inline-block;
          height: 400px;
          width: 100%;
          .no_data {
            background-color: #ffffff;
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 160px;
              height: 160px;
              margin-bottom: 10px;
            }
            .text {
              font-size: 14px;
              font-weight: 400;
              color: #969799;
            }
          }
        }
      }
    }
  }
}
</style>
